<template>
	<div class="main">
		<div class="naverwebtoon">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<a href=""><img src="../assets/image/naverwebtoon_bigbanner.png" alt=""></a>
		</div>
		<div class="box">
			<Header></Header>
			<img class="loading" :src="game.topBgImage" alt="">
			<div class="item_welfare">
				<div class="content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="describe">
						<img src="../assets/image/push.png" alt="">
						<span>|</span>
						<p class="marquee"><span>{{ horseRaceLamp }}</span></p>
					</div>
					<div class="position">
						<div class="items-grid">
							<div v-for="(item, index) in dailyRewards" :key="index" class="item-card">
								<div class="day-label">วัน {{ index + 1 }}</div>
								<div class="item-title">{{ item.describe }}</div>
								<div class="item-image">
									<img :src="item.image" :alt="item.describe">
									<div v-if="item.status == 2" class="completed-mark">
										<div class="check-circle">
											<svg width="62" height="62" viewBox="0 0 32 32" fill="none"
												xmlns="http://www.w3.org/2000/svg" class="text-accent">
												<path
													d="M11.5 16.0001L14.5 19.0001L21.25 12.2501M9.00065 3.7281C10.2064 3.63188 11.3511 3.15775 12.2717 2.37319C14.4201 0.542351 17.5799 0.542351 19.7283 2.37319C20.6489 3.15775 21.7936 3.63188 22.9993 3.7281C25.8131 3.95264 28.0474 6.18698 28.272 9.00071C28.3682 10.2065 28.8423 11.3511 29.6269 12.2718C31.4577 14.4201 31.4577 17.58 29.6269 19.7284C28.8423 20.649 28.3682 21.7937 28.272 22.9994C28.0474 25.8131 25.8131 28.0475 22.9993 28.272C21.7936 28.3682 20.6489 28.8424 19.7283 29.6269C17.5799 31.4578 14.4201 31.4578 12.2717 29.6269C11.3511 28.8424 10.2064 28.3682 9.00065 28.272C6.18692 28.0475 3.95258 25.8131 3.72804 22.9994C3.63182 21.7937 3.15769 20.649 2.37313 19.7284C0.54229 17.58 0.54229 14.4201 2.37313 12.2718C3.15769 11.3511 3.63182 10.2065 3.72804 9.00071C3.95258 6.18698 6.18692 3.95264 9.00065 3.7281Z"
													stroke="#fdd100" stroke-width="2" stroke-linecap="round"
													stroke-linejoin="round"></path>
											</svg>
										</div>
									</div>
								</div>
								<button :id="'btn_' + (index + 1)"
									v-on:click="receiveDailyRewards(index + 1, item.status)"
									:class="['item-button', item.status == 1 ? 'bg_color' : 'inactive-button']">
									<svg v-if="item.status == 0" class="lock-icon" viewBox="0 0 24 24" width="14"
										height="14">
										<path
											d="M19,10h-1V7c0-4-3-7-7-7S4,3,4,7v3H3c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-8C21,10.9,20.1,10,19,10z M12,17c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,17,12,17z M15,10H9V7c0-1.7,1.3-3,3-3s3,1.3,3,3V10z"
											fill="currentColor" />
									</svg>
									<span v-if="loadingDay === index + 1 && item.status == 1"></span>
									<span v-if="item.status != 0 && loadingDay == null">{{ item.status == 2 ?
										'เสร็จแล้ว'
										: 'รางวัล' }}</span>
								</button>
							</div>
						</div>
						<div class="game-rules">
							<h3>กติกาโปร:</h3>
							<p>{{ gameRules }}</p>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
		<TipsWindow ref="tips"></TipsWindow>
		<!-- 添加奖励领取成功弹窗 -->
		<!-- 修改烟花容器的位置和结构 -->
		<div class="reward-modal" v-if="showRewardModal" @click.self="closeRewardModal">
			<!-- 将烟花容器移到这里，使其覆盖整个模态框 -->
			<div class="fireworks-container" v-if="showFireworks">
				<div class="firework-rocket" v-for="n in 10" :key="n"></div>
			</div>

			<div class="reward-modal-content">
				<div class="reward-modal-header">
					<div class="header-decoration"></div>
					<h3>ยินดีด้วยที่ได้รับรางวัล</h3>
					<span class="close-btn" @click="closeRewardModal">&times;</span>
				</div>
				<div class="reward-modal-body">
					<div class="reward-image-container">
						<div class="reward-image-wrapper">
							<img :src="currentReward.image" :alt="currentReward.describe">
							<div class="reward-glow"></div>
						</div>
					</div>
					<div class="reward-info">
						<p class="reward-title">{{ currentReward.describe }}</p>
						<p class="reward-desc">ชาร์จ อิมมอร์ทัล เจดวันนี้ เพื่อรับส่วนลด 15% รีชาร์จ 60 อิมมอร์ทัล เจด
							เพื่อรับ 69 อิมมอร์ทัล เจด!</p>
					</div>
				</div>
				<div class="reward-modal-footer">
					<button class="confirm-btn" @click="closeRewardModal">
						<span>ยืนยัน</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import TipsWindow from '../components/tipsWindow.vue'
import axios from 'axios'
import {
	isEmpty,
	isNotEmpty
} from '../utils/index.js'
export default {
	name: 'dailySignIn',
	components: {
		Header,
		Footer,
		UserInfo,
		TipsWindow
	},
	data() {
		return {
			rewardMode: 0,
			activityCode: 'dailyCheckIn',
			game: this.$store.state.gameData,
			dailyRewards: [],
			loadingDay: null,
			totalDays: 0,
			showRewardModal: false, // 控制奖励弹窗显示
			currentReward: {}, // 当前领取的奖励信息
			showFireworks: false, // 控制礼花效果显示
			horseRaceLamp: "",
			gameRules: 'รางวัลรายวันสามารถขอรับได้เพียงครั้งเดียวต่อวัน และคุณสามารถขอรับรางวัลในวันถัดไปได้หลังจากที่คุณได้ครบรางวัลในวันนั้น ผู้เล่นที่เรียกร้องมา 15 วันติดต่อกันและ 29 วันสามารถรับแพ็คเกจของซูเปอร์โบนัสในวันที่ 16 และ 30'
		}
	},
	mounted() {
		this.initDailyRewardsData();
	},
	methods: {
		loadDailyRewardsJson: function (meetDays) {
			axios.get('/static/json/daily_rewards/' + this.game.gameCode + '.json?v' + (new Date()).getTime())
				.then((response) => {
					this.horseRaceLamp = response.data.horseRaceLamp;
					const self = this;
					response.data.dataList.forEach(function (obj, index) {
						if (index < self.totalDays) {
							self.dailyRewards.push(obj)
						}
					});
					Object.keys(meetDays).forEach(key => {
						self.dailyRewards[key - 1].status = meetDays[key];
					});
				});
		},
		initDailyRewardsData: function () {
			if (this.$session.hasLogin()) {
				this.$axios({
					method: 'get',
					url: '/web/api/dailyReward/initData',
					params: {
						actCode: this.activityCode,
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
					}
				})
					.then(response => {
						if (response.code === 1000) {
							let meetDays = response.data.meetDays;
							this.totalDays = response.data.totalDays;
							this.loadDailyRewardsJson(meetDays);
						}
					})
			} else {
				this.totalDays = 31;
				this.loadDailyRewardsJson([]);
			}
		},
		receiveDailyRewards: function (day, status) {
			if (status != 1) return;
			let _role = this.$cache.getRoleInfo();
			if (isEmpty(_role)) {
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}
			this.$setLoading('btn_' + day, true);
			// 设置加载状态
			this.loadingDay = day;

			this.$axios({
				method: 'get',
				url: '/web/api/dailyReward/receive',
				params: {
					actCode: this.activityCode,
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode(),
					serverCode: _role.serverCode,
					roleId: _role.roleId,
					day: day
				}
			})
				.then(response => {
					if (response.code === 1000) {
						let index = day - 1;
						// 保存当前领取的奖励信息
						this.currentReward = this.dailyRewards[index];
						this.dailyRewards[index].status = 2;
						// 显示奖励弹窗
						this.showRewardModal = true;
						// 显示礼花效果
						this.showFireworksEffect();
					} else if (response.code === 9000) {
						this.$refs.tips.show('ยังเช็กอินไม่ครบหรือเช็กอินไปแล้ว!');
					} else {
						this.$refs.tips.show(response.message);
					}
					this.$setLoading('btn_' + day, false);
					this.loadingDay = null;
				})
				.finally(() => {
					// 无论成功失败，都重置加载状态
					setTimeout(() => {
						this.loadingDay = null;
					}, 500);
				});
		},
		// 修改显示礼花效果的方法为烟花效果
		showFireworksEffect: function () {
			this.showFireworks = true;
			// 创建烟花效果
			setTimeout(() => {
				const rockets = document.querySelectorAll('.firework-rocket');
				rockets.forEach(rocket => {
					// 随机设置烟花爆炸位置
					const left = Math.random() * 90 + 5; // 5% - 95%
					const top = Math.random() * 70 + 5; // 5% - 75%

					// 设置烟花发射起点和目标位置
					rocket.style.setProperty('--target-left', `${left}%`);
					rocket.style.setProperty('--target-top', `${top}%`);

					// 随机设置烟花颜色
					const hue = Math.floor(Math.random() * 360);
					const saturation = 80 + Math.random() * 20; // 80-100%
					const lightness = 50 + Math.random() * 10; // 50-60%
					rocket.style.setProperty('--firework-color',
						`hsl(${hue}, ${saturation}%, ${lightness}%)`);

					// 随机设置发射延迟
					const delay = Math.random() * 3;
					rocket.style.animationDelay = `${delay}s`;
				});
			}, 50);

			// 8秒后自动隐藏烟花效果
			setTimeout(() => {
				this.showFireworks = false;
			}, 8000);
		},

		// 关闭奖励弹窗时同时关闭烟花效果
		closeRewardModal: function () {
			this.showRewardModal = false;
			this.showFireworks = false; // 确保关闭烟花效果
		}
	}
}
</script>
<style>
@import '../assets/css/daily_rewards.css';
</style>
<style scoped>
/* 修改天数标签样式，使其更符合图片效果 */
.day-label {
	background-color: #fdd100;
	color: white;
	font-weight: bold;
	padding: 10px 8px 2px 8px;
	border-radius: 12px 12px 12px 12px;
	position: absolute;
	top: -10px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 13px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
	z-index: 2;
	width: 50px;
	text-align: center;
}

/* 确保item-card有相对定位，以便天数标签可以正确定位 */
.item-card {
	position: relative;
	padding-top: 15px;
	margin-top: 15px;
	/* 调整顶部间距 */
	border-radius: 8px;
	overflow: hidden;
	background-color: white;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.inactive-button {
	background-color: #888888 !important;
	color: #cccccc;
	position: relative;
	cursor: not-allowed;
}

/* 确保按钮内容垂直居中 */
.item-button {
	display: flex;
	align-items: center;
	justify-content: center;
}

.item-button span {
	display: inline-flex;
	align-items: center;
}



/* 优化后的奖励弹窗样式 */
.reward-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 10000;
	backdrop-filter: blur(3px);
}

.reward-modal-content {
	background: linear-gradient(to bottom, #ffffff, #f5f5f5);
	border-radius: 16px;
	width: 85%;
	max-width: 360px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
	overflow: hidden;
	animation: modal-appear 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	border: 1px solid rgba(255, 255, 255, 0.2);
	position: relative;
}

@keyframes modal-appear {
	from {
		opacity: 0;
		transform: scale(0.8) translateY(-40px);
	}

	to {
		opacity: 1;
		transform: scale(1) translateY(0);
	}
}

.reward-modal-header {
	background: linear-gradient(135deg, #fdd100, #ffb300);
	color: white;
	padding: 14px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	overflow: hidden;
}

.header-decoration {
	position: absolute;
	top: -20px;
	right: -20px;
	width: 100px;
	height: 100px;
	background: rgba(255, 255, 255, 0.15);
	border-radius: 50%;
}

.reward-modal-header h3 {
	margin: 0;
	font-size: 20px;
	font-weight: 600;
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
	position: relative;
	z-index: 1;
}

.close-btn {
	font-size: 28px;
	cursor: pointer;
	color: white;
	opacity: 0.8;
	transition: opacity 0.2s;
	position: relative;
	z-index: 1;
	line-height: 0.8;
}

.close-btn:hover {
	opacity: 1;
}

.reward-modal-body {
	padding: 25px 20px 15px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.reward-image-container {
	margin-bottom: 20px;
	position: relative;
}

.reward-image-wrapper {
	width: 120px;
	height: 120px;
	background: linear-gradient(to bottom, #f9f9f9, #efefef);
	border-radius: 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
	position: relative;
	overflow: hidden;
	border: 1px solid rgba(0, 0, 0, 0.05);
	animation: image-pulse 2s infinite ease-in-out;
}

@keyframes image-pulse {
	0% {
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
	}

	50% {
		box-shadow: 0 5px 25px rgba(253, 209, 0, 0.3);
	}

	100% {
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
	}
}

.reward-glow {
	position: absolute;
	top: -50%;
	left: -50%;
	width: 200%;
	height: 200%;
	background: radial-gradient(circle, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 70%);
	opacity: 0;
	animation: glow-rotate 4s infinite linear;
}

@keyframes glow-rotate {
	0% {
		transform: rotate(0deg);
		opacity: 0;
	}

	25% {
		opacity: 0.5;
	}

	50% {
		transform: rotate(180deg);
		opacity: 0;
	}

	75% {
		opacity: 0.5;
	}

	100% {
		transform: rotate(360deg);
		opacity: 0;
	}
}

.reward-image-wrapper img {
	max-width: 85%;
	max-height: 85%;
	object-fit: contain;
	filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.2));
	animation: float 3s infinite ease-in-out;
	z-index: 1;
}

@keyframes float {

	0%,
	100% {
		transform: translateY(0);
	}

	50% {
		transform: translateY(-5px);
	}
}

.reward-info {
	text-align: center;
	width: 100%;
}

.reward-title {
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 8px;
	color: #333;
}

.reward-desc {
	font-size: 14px;
	color: #666;
	margin-bottom: 5px;
}

.reward-modal-footer {
	padding: 15px 20px 20px;
	text-align: center;
}

.confirm-btn {
	background: linear-gradient(135deg, #fdd100, #ffb300);
	color: white;
	border: none;
	padding: 11px 0;
	border-radius: 30px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s;
	width: 80%;
	box-shadow: 0 4px 10px rgba(253, 209, 0, 0.3);
	position: relative;
	overflow: hidden;
}

.confirm-btn::before {
	content: '';
	position: absolute;
	top: 0;
	left: -100%;
	width: 100%;
	height: 100%;
	background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
	transition: all 0.6s;
}

.confirm-btn:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 15px rgba(253, 209, 0, 0.4);
}

.confirm-btn:hover::before {
	left: 100%;
}

.confirm-btn:active {
	transform: translateY(1px);
	box-shadow: 0 2px 5px rgba(253, 209, 0, 0.4);
}




/* 替换礼花效果样式为烟花效果样式 */
.fireworks-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 10001;
	/* 确保在模态框内容之上 */
	overflow: hidden;
}

.firework-rocket {
	position: absolute;
	bottom: -10px;
	width: 2px;
	/* 减小宽度 */
	height: 2px;
	/* 减小高度 */
	background-color: #fff;
	border-radius: 50%;
	z-index: 10001;
	transform-origin: center bottom;
	animation: rocket-launch 1.5s ease-out forwards;
}

/* 设置不同烟花的位置和颜色 */
.firework-rocket:nth-child(1) {
	left: 20%;
	animation-delay: 0.2s;
}

.firework-rocket:nth-child(2) {
	left: 40%;
	animation-delay: 0.7s;
}

.firework-rocket:nth-child(3) {
	left: 60%;
	animation-delay: 1.2s;
}

.firework-rocket:nth-child(4) {
	left: 80%;
	animation-delay: 1.7s;
}

.firework-rocket:nth-child(5) {
	left: 30%;
	animation-delay: 2.2s;
}

.firework-rocket:nth-child(6) {
	left: 70%;
	animation-delay: 2.7s;
}

/* 添加更多烟花位置 */
.firework-rocket:nth-child(7) {
	left: 25%;
	animation-delay: 0.5s;
}

.firework-rocket:nth-child(8) {
	left: 55%;
	animation-delay: 1.0s;
}

.firework-rocket:nth-child(9) {
	left: 85%;
	animation-delay: 1.5s;
}

.firework-rocket:nth-child(10) {
	left: 15%;
	animation-delay: 2.0s;
}

/* 烟花发射动画 - 减小爆炸效果 */
@keyframes rocket-launch {
	0% {
		transform: translateY(0) scale(1);
		background-color: #fff;
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
	}

	/* 上升阶段 - 添加尾迹 */
	40% {
		transform: translate(calc(var(--target-left) - 50%), calc(var(--target-top) - 50vh)) scale(1);
		background-color: #fff;
		box-shadow: 0 0 3px 1px rgba(255, 255, 255, 0.8), 0 0 6px 3px rgba(255, 255, 255, 0.4);
		/* 减小尾迹 */
	}

	/* 爆炸阶段 */
	41% {
		transform: translate(calc(var(--target-left) - 50%), calc(var(--target-top) - 50vh)) scale(1);
		background-color: var(--firework-color, #ff5252);
		box-shadow: 0 0 3px 1px var(--firework-color, #ff5252);
		/* 减小光晕 */
	}

	/* 爆炸扩散 - 减小扩散范围 */
	43% {
		transform: translate(calc(var(--target-left) - 50%), calc(var(--target-top) - 50vh)) scale(10);
		/* 从15减小到10 */
		background-color: var(--firework-color, #ff5252);
		box-shadow: 0 0 12px 6px var(--firework-color, #ff5252), 0 0 24px 12px rgba(255, 255, 255, 0.4);
		/* 减小光晕 */
		opacity: 1;
	}

	/* 爆炸消失 */
	100% {
		transform: translate(calc(var(--target-left) - 50%), calc(var(--target-top) - 50vh)) scale(12);
		/* 从20减小到12 */
		background-color: var(--firework-color, #ff5252);
		box-shadow: 0 0 24px 12px rgba(255, 255, 255, 0);
		/* 减小光晕 */
		opacity: 0;
	}
}

/* 添加烟花粒子效果 - 增强粒子效果 */
.firework-rocket::before,
.firework-rocket::after {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background-color: inherit;
	opacity: 0;
}

.firework-rocket::before {
	animation: firework-particles 1.5s ease-out 0.6s forwards;
}

.firework-rocket::after {
	animation: firework-particles 1.5s ease-out 0.8s forwards;
}

@keyframes firework-particles {
	0% {
		transform: scale(1) rotate(0deg);
		box-shadow:
			0 0 0 0px var(--firework-color, #ff5252),
			0 0 0 0px var(--firework-color, #ff5252),
			0 0 0 0px var(--firework-color, #ff5252),
			0 0 0 0px var(--firework-color, #ff5252),
			0 0 0 0px var(--firework-color, #ff5252),
			0 0 0 0px var(--firework-color, #ff5252),
			0 0 0 0px var(--firework-color, #ff5252),
			0 0 0 0px var(--firework-color, #ff5252);
		opacity: 0;
	}

	10% {
		opacity: 1;
	}

	100% {
		transform: scale(0.1) rotate(45deg);
		box-shadow:
			0 -40px 0 0px var(--firework-color, #ff5252),
			/* 从-60px减小到-40px */
			40px 0 0 0px var(--firework-color, #ff5252),
			/* 从60px减小到40px */
			0 40px 0 0px var(--firework-color, #ff5252),
			/* 从60px减小到40px */
			-40px 0 0 0px var(--firework-color, #ff5252),
			/* 从-60px减小到-40px */
			-30px -30px 0 0px var(--firework-color, #ff5252),
			/* 从-45px减小到-30px */
			30px -30px 0 0px var(--firework-color, #ff5252),
			/* 从45px减小到30px */
			30px 30px 0 0px var(--firework-color, #ff5252),
			/* 从45px减小到30px */
			-30px 30px 0 0px var(--firework-color, #ff5252);
		/* 从-45px减小到-30px */
		opacity: 0;
	}
}



/* 添加签到完成标记样式 */
.item-image {
	position: relative;
	overflow: hidden;
}

.completed-mark {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 3;
	animation: appear 0.5s ease-out forwards;
}

.check-circle {
	display: flex;
	justify-content: center;
	align-items: center;
}

.check-circle svg {
	color: #fdd100;
	filter: drop-shadow(0 0 5px rgba(253, 209, 0, 0.5));
}

@keyframes appear {
	0% {
		opacity: 0;
		transform: translate(-50%, -50%) scale(0.5);
	}

	70% {
		opacity: 1;
		transform: translate(-50%, -50%) scale(1.1);
	}

	100% {
		transform: translate(-50%, -50%) scale(1);
	}
}
</style>